import { QueryClient, focusManager } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Navigate } from 'react-router';

import { userKeys } from '../queries/query-keys';
import { sessionKeys } from '../queries/sessionQuery';
import { setTime } from '../utils/setTime';

import { savePreLoginRouterState } from './routerUtils';

export const excludedPaths = ['signin', 'tos', 'request-demo'];

// disable focus manager for tanstack-query
// so when switching tabs it does not refetch data
focusManager.setFocused(false);

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			enabled: false, // disbaled so we do not make unathorized use requests
			refetchOnWindowFocus: false,
			staleTime: setTime(1, 'minutes'),
			throwOnError: (error: unknown, query) => {
				if (
					error instanceof AxiosError &&
					(error.response?.status === 401 || error.response?.status === 403) &&
					(query.queryKey[0] === userKeys.getUser || query.queryKey[0] === sessionKeys.getStatus()) &&
					globalThis.location.pathname !== '/' &&
					!excludedPaths.includes(globalThis.location.pathname)
				) {
					savePreLoginRouterState({
						redirectTo: globalThis.location.pathname,
						redirectParams: globalThis.location.search,
					});

					// Navigate to login page
					Navigate({ to: '/signin/login' });
					return false;
				}

				if (error instanceof AxiosError) {
					return error.response?.status ? error.response.status >= 500 : false;
				}
				return false;
			},
		},
	},
});
